import React from 'react';
import { motion } from 'framer-motion';
import { Star, TrendingUp, Award } from 'lucide-react';
import { Card } from "@/components/ui/card";

export default function PointsDisplay({ userPoints, compact = false }) {
  if (!userPoints) return null;

  const getLevelName = (level) => {
    if (level >= 10) return 'Maestro';
    if (level >= 7) return 'Experto';
    if (level >= 5) return 'Avanzado';
    if (level >= 3) return 'Intermedio';
    return 'Principiante';
  };

  const pointsToNextLevel = (userPoints.level * 100) - (userPoints.total_points % (userPoints.level * 100));

  if (compact) {
    return (
      <div className="flex items-center gap-1 px-2 py-1.5 bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl border border-amber-200">
        <Star className="w-3.5 h-3.5 fill-amber-500 text-amber-500 flex-shrink-0" />
        <span className="font-bold text-amber-900 text-sm">{userPoints.available_points}</span>
        <span className="text-[10px] text-amber-700 hidden xs:inline">pts</span>
      </div>
    );
  }

  return (
    <Card className="p-6 bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 border-2 border-amber-200">
      <div className="flex items-start justify-between mb-4">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <Star className="w-5 h-5 fill-amber-500 text-amber-500" />
            <h3 className="font-bold text-gray-900">Puntos de Fidelidad</h3>
          </div>
          <p className="text-sm text-gray-600">Nivel {userPoints.level} - {getLevelName(userPoints.level)}</p>
        </div>
        <Award className="w-8 h-8 text-amber-500" />
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <p className="text-3xl font-bold text-amber-900">{userPoints.available_points}</p>
          <p className="text-xs text-gray-600">Puntos disponibles</p>
        </div>
        <div>
          <p className="text-3xl font-bold text-gray-700">{userPoints.total_points}</p>
          <p className="text-xs text-gray-600">Puntos totales</p>
        </div>
      </div>

      <div className="space-y-2">
        <div className="flex items-center justify-between text-xs text-gray-600">
          <span>Progreso al nivel {userPoints.level + 1}</span>
          <span>{pointsToNextLevel} pts restantes</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: `${((userPoints.total_points % (userPoints.level * 100)) / (userPoints.level * 100)) * 100}%` }}
            className="h-2 rounded-full bg-gradient-to-r from-amber-500 to-orange-500"
          />
        </div>
      </div>

      {userPoints.badges && userPoints.badges.length > 0 && (
        <div className="mt-4 pt-4 border-t border-amber-200">
          <p className="text-xs text-gray-600 mb-2">Insignias obtenidas</p>
          <div className="flex flex-wrap gap-2">
            {userPoints.badges.map((badge, index) => (
              <span key={index} className="text-2xl">{badge}</span>
            ))}
          </div>
        </div>
      )}
    </Card>
  );
}